import {
  Component,
  OnInit,
  ViewEncapsulation,
  ChangeDetectorRef,
  OnDestroy,
} from "@angular/core";
import { ModalController } from "@ionic/angular";
import { AppService } from "src/app/app.service";
import { BaseInjectorService } from "src/app/base/base-service.injector";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import {
  SearchCountryField,
  CountryISO,
  PhoneNumberFormat,
} from "ngx-intl-tel-input";
import { RapidtourService } from "src/app/services/rapid-tour/rapidtour.service";
import { Keyboard } from "@capacitor/keyboard";
import { Capacitor } from "@capacitor/core";

@Component({
  selector: "add-contractor",
  templateUrl: "./add-contractor.component.html",
  styleUrls: ["./add-contractor.component.scss"],
  standalone: false
})
export class AddContractorComponent
  extends BaseInjectorService
  implements OnInit, OnDestroy {
  addContractorForm: FormGroup;
  employee_type: string = "Employee";
  company_list: any = [];
  phoneForm = new FormGroup({
    phone: new FormControl(null, [Validators.required]),
  });
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [];
  validationtext: string = "";
  shield_info: any;
  isRadioButtonSelected: boolean = false;
  keyboardHeight: number = 0;
  private keyboardListener: any;

  constructor(
    public modalController: ModalController,
    private appservice: AppService,
    public formBuilder: FormBuilder,
    private rapidService: RapidtourService,
    private changeRef: ChangeDetectorRef
  ) {
    super();
    this.addContractorForm = this.formBuilder.group({
      First_Name: [null, Validators.required],
      Last_Name: [null, Validators.required],
      Company_Name: [null, Validators.required],
      Email: [
        "",
        [
          Validators.email,
          Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
        ],
      ],
    });
  }

  async ngOnInit() {
    this.shield_info = await this.lhStorage.get("currentRapid");
    this.setupKeyboardListeners();
  }

  setupKeyboardListeners() {
    if (Capacitor.isNativePlatform()) {
      this.keyboardListener = Keyboard.addListener('keyboardWillShow', (info) => {
        this.keyboardHeight = info.keyboardHeight;
        // Scroll the focused input into view
        setTimeout(() => {
          const activeElement = document.activeElement;
          if (activeElement) {
            activeElement.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'nearest'
            });
          }
        }, 300);
      });

      Keyboard.addListener('keyboardWillHide', () => {
        this.keyboardHeight = 0;
      });
    }
  }

  ngOnDestroy() {
    if (this.keyboardListener) {
      this.keyboardListener.remove();
    }
  }

  async ionViewDidEnter() {
    this.addContractorForm
      .get("Company_Name")
      .valueChanges.subscribe((newValue) => {
        if (newValue != "" && newValue != null) this.searchCompany(newValue);
        else this.company_list = [];
      });
    this.employeeTypeSelect(this.employee_type, false);
  }

  employeeTypeSelect(event: any, isChoosen: boolean) {
    if (isChoosen) {
      this.employee_type = event.target.value;
    }

    if (this.employee_type == "Employee") {
      this.addContractorForm.controls["Company_Name"].clearValidators();
      this.addContractorForm.controls["Company_Name"].updateValueAndValidity();
    } else {
      this.addContractorForm.controls["Company_Name"].setValidators(
        Validators.required
      );
      this.addContractorForm.controls["Company_Name"].updateValueAndValidity();
    }
    this.changeRef.detectChanges();
  }

  async searchCompany(name: any) {
    if (name != null) {
      const filter_value = await this.rapidService.getOrganizationSearchList(
        this.shield_info.country_name,
        name
      );
      this.company_list = filter_value;
    } else {
      this.company_list = [];
    }
  }
  createForm() { }
  closeBtnClick() {
    this.closePopup({ status: "cancel", data: "" });
  }
  closePopup(obj) {
    this.modalController.dismiss(obj);
  }
  async addContractor(obj) {
    let phone_form_data: any = this.phoneForm.value;
    let isValid = !this.phoneForm.controls["phone"].invalid;
    if (this.phoneForm.controls["phone"].touched) {
      if (isValid) this.validationtext = "";
      else {
        this.validationtext = this.translate.instant(
          "ADD_CONTRACTOR_COMPONENT.ENTER_VALID_MOBILE_NUMBER"
        );
        return;
      }
    }

    await this.overlayService.presentLoading(
      this.createLoaderOptions(this.translate.instant("APP_LOADING_LABEL"))
    );
    // obj.id=this.firestore.createId();
    obj.status = "created";
    obj.created_by = this.appservice.appData.userInfo.email;
    obj.created_person_id = this.appservice.appData.userInfo.person_id;
    obj.created_date = this.moment().format("YYYY-MM-DD");
    obj.created_datetime = this.moment().toISOString();
    obj.source = "BOG";
    obj.relation = this.employee_type;
    obj.active = "Yes";
    obj.Country = this.shield_info.country_name;
    obj.plant = this.shield_info.plant_name;
    obj.location_unique_id = this.shield_info.plant_unique_id;
    obj.Full_Name = `${obj.First_Name} ${obj.Last_Name}`;
    obj.full_name_lower = `${obj.First_Name.toLowerCase()} ${obj.Last_Name.toLowerCase()}`;
    obj.phone = "";
    obj.countryCode = "";
    obj.dialCode = "";
    if (phone_form_data.phone != null) {
      obj.phone = phone_form_data?.phone?.number;
      obj.countryCode = phone_form_data?.phone?.countryCode;
      obj.dialCode = phone_form_data?.phone?.dialCode;
    }
    if (this.employee_type == "Employee") obj.Company_Name = "Holcim";
    if (this.employee_type != "Employee" && obj.Company_Name == "") return;
    obj.email_hide = false;
    if (obj.Email.trim() == "" || obj.Email.trim() == null) {
      obj.Email =
        obj.Email ||
        (obj.First_Name + " " + obj.Last_Name + "@nonboguser.com").replace(
          /\s+/g,
          ""
        );
      obj.email_hide = true;
    }

    obj.id = obj.Email;
    this.lhFire.addData(`gad_employees`, obj);
    this.overlayService.dismissLoading();
    this.closePopup({ status: "ok", data: obj });
  }
}
